<template>
  <div>
    <b-modal :active.sync="operationModal.active" :width="'90vw'" has-modal-card>
      <order-operations-modal
        :order="order"
        :operation="operation"
        :operation-code-ids="getOperationCodeIds(['ASSET', 'REACTIVE', 'RESPONSE', 'FAILURE', 'REPAIR'])"
        :disabled="!canManageOperationsBoolean"
        @select="onOperationModalSelect"
      />
    </b-modal>
    <table class="table is-fullwidth is-bordered">
        <tbody>

            <tr>
                <th colspan="2" class="has-background-dark has-text-light">
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <span>Activities & Assets</span>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item"></div>
                            <div class="level-item">
                                <div class="buttons">
                                  <b-button
                                      class="has-text-weight-bold"
                                      type="is-danger"
                                      size="is-small"
                                      :loading="deleting"
                                      @click="confirmDelete"
                                      v-if="canManageOperationsBoolean && canForceDeleteOperation"
                                  >
                                    DELETE
                                  </b-button>
                                  <b-button
                                      id="save_operation"
                                      class="has-text-weight-bold"
                                      size="is-small"
                                      :loading="updating"
                                      :disabled="!canManageOperationsBoolean || deleting"
                                      :title="
                                        canManageOperations && !canManageOperations.value
                                          ? canManageOperations.help[0]
                                          : ''
                                      "
                                      @click="update"
                                      v-if="(canBeCompletedByUser && canBeCompletedByUser.value) || (canUserEditOperation || canIssuingFirmUserUpdateOperation(order, operation))"
                                  >
                                    SAVE
                                  </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>

            <tr>
                <th>Description</th>
                <td>
                  <b-input
                    v-model="form.description"
                    :disabled="!canUserEditOperation || !order.editable"
                  />
                </td>
            <tr>
                <th>Activity Owner</th>
                <td>
                  <b-field>

                    <b-select expanded placeholder="Please Select"
                      v-model="form.activityOwner"
                      @input="updateActivityOwner"
                      :disabled="!canManageOrders"
                      v-if="order.status === 'BLRQ' && isBelongToIssuingFirm(order)">
                        <option :value="firm.child_id" v-for="(firm, key) in associated">{{ firm.firm_name.name }}</option>
                    </b-select>

                    <b-select expanded placeholder="Please Select"
                      v-else
                      v-model="form.activityOwner"
                      :disabled="!canUserEditOperation || !order.editable">
                        <option :value="firm.child_id" v-for="(firm, key) in associated">{{ firm.firm_name.name }}</option>
                    </b-select>

                  </b-field>

                  <!-- <base-select
                    :service="$options.firmService"
                    fetch-func="all"
                    :fetch-params="{ activityOwner: 1 }"
                    :value.sync="form.activityOwner"
                    :disabled="!canManageOrders"
                    @input:manual="updateActivityOwner"
                    v-if="order.status === 'BLRQ' && isBelongToIssuingFirm"
                  ></base-select>
                  <base-select
                    :service="$options.firmService"
                    fetch-func="all"
                    :fetch-params="{ activityOwner: 1 }"
                    :value.sync="form.activityOwner"
                    :disabled="!canManageOperationsBoolean || !order.editable"
                    v-else
                  ></base-select> -->


                </td>
            </tr>
            <tr>
                <th>Activity Type</th>
                <td>
                  <base-select
                    :service="$options.codeService"
                    fetch-func="chained"
                    :fetch-params="{
                      ids: getOperationCodeIds('ACTIVITY'),
                      type: 'ACTIVITY',
                      contract_id: order.contract_id || undefined,
                    }"
                    :value.sync="form.activityType"
                    :prepend="operation.activityCode ? [operation.activityCode] : []"
                    :disabled="!canChangeActivity || !canUserEditOperation || !order.editable"
                    :loading="fetchingCodes"
                    ref="selectActivityType"
                  ></base-select>
                </td>
            </tr>
            <tr>
                <th>Asset Type</th>
                <td v-if="operation.noAsset == 1 || ORPair">Not Applicable</td>
                <td v-else-if="operation.asset">
                  {{ operation.asset.code ? `${operation.asset.code.code} - ${operation.asset.code.name}` : "" }}
                </td>
                <td v-else>{{ operation.locationId || "" }}</td>
            </tr>
            <tr>
                <th>Asset ID</th>

                <td v-if="operation.noAsset == 1 || ORPair">Not Applicable</td>

                <td v-else>

                  {{ operation.asset ? (operation.asset.thirdPartyCode != null ? operation.asset.thirdPartyCode : operation.asset.id)  : '' }}

                  <!-- <span v-if="$store.state.Auth.user.firmId == order.firm_id"> -->

                    <b-button
                      :id="`${canUserEditOperation ? 'update' : 'view'}_operation_asset`"
                      size="is-small"
                      type="is-light"
                      class="has-text-weight-bold"
                      @click='viewMap'
                    >
                      {{ canUserEditOperation ? "UPDATE" : "VIEW" }} ASSET
                    </b-button>

                    <b-button
                      v-if="operation.form"
                      id="view_form"
                      size="is-small"
                      type="is-light"
                      class="has-text-weight-bold"
                      @click="() => viewForm(order, operation)"
                    >
                      {{ operation.form.id_alt }}
                    </b-button>
                    <span v-else>
                      <b-button
                        id="inspect_operation"
                        size="is-small"
                        type="is-light"
                        class="has-text-weight-bold"
                        :disabled="!canInspect(order, operation)"
                        @click="() => inspect(order, operation, false)"
                      >
                        INSPECT
                      </b-button>
                      <b-button
                        id="inspect_hotspot_operation"
                        size="is-small"
                        type="is-light"
                        class="has-text-weight-bold"
                        :disabled="!canInspect(order, operation)"
                        @click="() => inspect(order, operation, true)"
                      >
                        HOTSPOT
                      </b-button>
                    </span>

                    <!-- <b-button
                      id="view_operation_asset"
                      size="is-small"
                      type="is-light"
                      class="has-text-weight-bold"
                      @click='viewMap'
                    >
                      VIEW ASSET MAP
                    </b-button> -->

                  <!-- </span> -->

                </td>
            </tr>

            <tr v-if="ORPair">
                <th>Outcome</th>
                <td>
                  <base-select
                    name="outcome"
                    :service="$options.codeService"
                    fetch-func="chained"
                    :fetch-params="{
                      ids: getOperationCodeIds('REACTIVE'),
                      type: 'REACTIVE',
                      contract_id: order.contract_id || undefined,
                    }"
                    :fetch-on-init="false"
                    :value.sync="form.outcomeCode"
                    :prepend="operation.outcomeCode ? [operation.outcomeCode] : []"
                    :disabled="!areSummaryCodesEnabled || !canManageOperationsBoolean || !canManageOperationsByUserBoolean || !order.editable"
                    :loading="fetchingCodes"
                    disabled-on-empty
                    preselect-on-one
                    ref="selectOutcomeCode"
                  ></base-select>
                </td>
            </tr>
            <tr v-if="ORPair">
                <th>Responsibility</th>
                <td>
                   <base-select
                    name="responsibility"
                    :service="$options.codeService"
                    fetch-func="chained"
                    :fetch-params="{
                      ids: getOperationCodeIds('RESPONSE'),
                      type: 'RESPONSE',
                      contract_id: order.contract_id || undefined,
                    }"
                    :fetch-on-init="false"
                    :value.sync="form.responsibilityCode"
                    :prepend="operation.responsibilityCode ? [operation.responsibilityCode] : []"
                    :disabled="!areSummaryCodesEnabled || !canManageOperationsBoolean || !canManageOperationsByUserBoolean || !order.editable"
                    :loading="fetchingCodes"
                    disabled-on-empty
                    preselect-on-one
                    ref="selectResponsibilityCode"
                  ></base-select>
                </td>
            </tr>
            <tr v-if="!ORPair">
                <th>Failure</th>
                <td>
                  <base-select
                    name="failure"
                    :service="$options.codeService"
                    fetch-func="chained"
                    :fetch-params="{
                      ids: getOperationCodeIds('FAILURE'),
                      type: 'FAILURE',
                      contract_id: order.contract_id || undefined,
                    }"
                    :fetch-on-init="false"
                    :value.sync="form.failureCode"
                    :prepend="operation.failureCode ? [operation.failureCode] : []"
                    :disabled="!areSummaryCodesEnabled || !canManageOperationsBoolean || !canManageOperationsByUserBoolean || !order.editable"
                    :loading="fetchingCodes"
                    disabled-on-empty
                    preselect-on-one
                    ref="selectFailureCode"
                  ></base-select>
                </td>
            </tr>
            <tr v-if="!ORPair">
                <th>Repair</th>
                <td>
                  <base-select
                    name="repair"
                    :service="$options.codeService"
                    fetch-func="chained"
                    :fetch-params="{
                      ids: getOperationCodeIds('REPAIR'),
                      type: 'REPAIR',
                      contract_id: order.contract_id || undefined,
                    }"
                    :fetch-on-init="false"
                    :value.sync="form.repairCode"
                    :prepend="operation.repairCode ? [operation.repairCode] : []"
                    :disabled="!areSummaryCodesEnabled || !canManageOperationsBoolean || !canManageOperationsByUserBoolean|| !order.editable"
                    :loading="fetchingCodes"
                    disabled-on-empty
                    preselect-on-one
                    ref="selectRepairCode"
                  ></base-select>
                </td>
            </tr>
            <tr>
                <th>Tags</th>
                <td>
                  <!-- <b-taglist>
                    <b-tag type="is-dark" v-for="tag in (operation.tags || [])" :key="tag.id">
                      {{ tag.name }}
                    </b-tag>
                  </b-taglist> -->
                  <base-tag-input
                    :value.sync="operation.tags"
                    model-type="orderOperation"
                    :model-id="operation.id"
                    attach-mode
                    allow-new
                    label=""
                  />
                </td>
            </tr>

            <tr v-if="canInvoiceInternalOrders">
                <th colspan="2" class="has-background-dark has-text-light">
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <span>Claim & Invoicing</span>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <button
                                  id="add_operation_claim_line"
                                  class="button is-light is-small has-text-weight-bold"
                                  :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || !order.editable"
                                  :title="
                                    canManageClaimLinesByUser &&
                                    canManageClaimLinesByUser.value === 'disabled'
                                      ? canManageClaimLinesByUser.help[0]
                                      : ''
                                  "
                                  @click="openClaimLineModal"
                                  v-if="
                                    (canManageClaimLines &&
                                      canManageClaimLines.value) &&
                                    (canManageClaimLinesByUser &&
                                      canManageClaimLinesByUser.value)
                                  "
                                >
                                  ADD CLAIM LINE
                                </button>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>

            <tr v-if="canInvoiceInternalOrders">
              <td colspan="2">

              </td>
            </tr>

            <tr v-if="canInvoiceInternalOrders">
                <th>
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">

                                <b-field grouped>

                                    <div class="block"
                                      v-if="
                                        (canManageClaimLines &&
                                          canManageClaimLines.value) &&
                                        (canManageClaimLinesByUser &&
                                          canManageClaimLinesByUser.value)
                                      "
                                    >

                                        <b-radio
                                            v-model="status"
                                            :name="`${operation.id}-chargeable`"
                                            native-value="BLRQ"
                                            :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || claimLines.length === 0 || !order.editable"
                                            >
                                            Chargeable
                                        </b-radio>

                                        <b-radio
                                            v-model="status"
                                            :name="`${operation.id}-nocharge`"
                                            native-value="FINALISED_NOBILLING"
                                            :disabled="(canManageClaimLinesByUser && canManageClaimLinesByUser.value === 'disabled') || claimLines.length > 0 || !order.editable"
                                            >
                                            No Charge
                                        </b-radio>

                                    </div>

                                    <!--
                                    <b-radio
                                    v-model="status"
                                    name="name"
                                    native-value="CLOSED_N">
                                    CANCEL {{ operation.id }}
                                    </b-radio> -->
                                    <!-- <b-field v-if="!isCompleted">
                                    <b-select
                                    size="is-small"
                                    :disabled="isCompleted"
                                    v-model="status"
                                    >
                                    <option value>Please select</option>
                                    <option
                                    v-for="status in $options.statuses"
                                    :value="status.value"
                                    :key="status.id"
                                    >{{ status.label }}</option
                                    >
                                    </b-select>
                                    <p class="control">
                                    <b-button
                                    size="is-small"
                                    :loading="updating"
                                    :disabled="isCompleted"
                                    @click="updateStatus"
                                    >Select</b-button
                                    >
                                    </p>
                                    </b-field>


                                    <b-field v-if="canComplete">
                                        <b-button
                                            type="is-success"
                                            size="is-small"
                                            v-if="isCompleted"
                                            >COMPLETED
                                        </b-button>
                                        <b-button
                                            type="is-danger"
                                            size="is-small"
                                            :loading="completing"
                                            @click="complete(operation.id)"
                                            v-else
                                            >COMPLETE
                                        </b-button>
                                    </b-field>
                                    -->

                                </b-field>

                            </div>
                        </div>
                    </div>
                </th>
                <th>
                    <div v-if="order.billing_code">
                        <strong>CLAIM ID:</strong>
                        <span>{{ order.billing_code }}</span>
                    </div>
                </th>
            </tr>

            <tr v-if="canInvoiceInternalOrders">
                <td colspan="2">
                    <order-operation-claim-lines
                        :order="order"
                        :operation-id="operation.id"
                        :operation.sync="operation"
                        :operation-code-ids="getOperationCodeIds()"
                        :claim-lines.sync="claimLines"
                        @created="onClaimLinesCreated"
                        @removed="onClaimLinesRemoved"
                        ref="claimLines"
                        @allClaimLinesDeleted="allClaimLinesDeleted"
                    />
                </td>
            </tr>

            <tr v-if="canCommentOnOperations">
                <th colspan="2" class="has-background-dark has-text-light">
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <span>Logs & Notes</span>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <b-button
                                  type="is-light"
                                  size="is-small"
                                  class="has-text-weight-bold"
                                  @click="openNoteModal"
                                  v-if="canCommentOnOperations"
                                  :disabled="!order.editable"
                                >
                                  ADD NOTE
                                </b-button>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>

            <tr v-if="canCommentOnOperations">
                <td colspan="2" ref="noteRow">
                    <order-operation-notes :operation-id="operation.id" :with-comments="canCommentOnOperations" ref="notes" />
                    <!-- <div :style="`height: 60px`" class="notes">
                    </div> -->
                </td>
            </tr>

        </tbody>
    </table>
  </div>
</template>

<script>

    import BaseSelect from "@/components/partials/BaseSelect";
    import BaseTagInput from "@/components/partials/BaseTagInput";
    import OrderOperationNotes from "./OrderOperationNotes";
    import OrderOperationClaimLines from "./OrderOperationClaimLines";
    import OrderOperationsModal from "./OrderOperationsModal";
    import { ConfigurationValidator } from "@/helpers/ConfigurationValidator";
    import { orderOperationMixin } from "@/components/Order/mixins/orderOperationMixin";
    import { CodeService } from "@/services/code.service";
    import { FirmService } from "@/services/firm.service";
    import { OrderOperationService } from "@/services/orderOperation.service";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
    import { AssociatedService } from "@/services/associated.service";

    export default {
      codeService: CodeService,
      firmService: FirmService,
      orderOperationService: OrderOperationService,
      associatedService: AssociatedService,
      statuses: [
        {
          label: "BLRQ",
          value: "BLRQ"
        },
        {
          label: "FINALISED_NOBILLING",
          value: "FINALISED_NOBILLING"
        },
        {
          label: "CLOSED_N",
          value: "CLOSED_N"
        },
        {
          label: "REJECTED",
          value: "REJECTED"
        }
      ],
      mixins: [orderOperationMixin],
      props: {
        order: {
          type: Object,
          required: true
        },
        operation: {
          type: Object,
          required: true
        },
        isFirst: {
          type: Boolean,
          default: false,
        },
        includes: {
          type: String
        }
      },
      components: {
        BaseSelect,
        BaseTagInput,
        OrderOperationNotes,
        OrderOperationClaimLines,
        OrderOperationsModal
      },
      data: () => ({
        status: "",
        claimLines: [],
        notesHeight: 0,
        updating: false,
        deleting: false,
        completing: false,
        fetchingCodes: false,
        form: {
          description: "",
          activityOwner: "",
          activityType: "",
          outcomeCode: "",
          responsibilityCode: "",
          failureCode: "",
          repairCode: ""
        },
        operationModal: {
          active: false
        },
        associated: []
      }),
      watch:{
        operation() {
          // Fix - form resets when selecting asset
          // this.setForm();
        },
        status(value){
          if(value != this.operation.status){
            this.updateStatus();
          }
        },
        areSummaryCodesRelevant(yes) {
          if (!yes) {
            this.form.outcomeCode = "";
            this.form.responsibilityCode = "";
            this.form.failureCode = "";
            this.form.repairCode = "";

            if (this.ORPair) {
              this.$refs.selectOutcomeCode.reset();
              this.$refs.selectResponsibilityCode.reset();
            } else {
              this.$refs.selectFailureCode.reset();
              this.$refs.selectRepairCode.reset();
            }
          }
        },
        operationCodes() {
          this.$nextTick(() => {
            this.fetchCodes();
          });
        }
      },
      computed: {
        canUserEditOperation() {
          // Method is temporary until we have OperationState
          // info similar to how we have OrderState info.
          // (we can simply update this method later)
          const operation_status = this.operation.status
            ? this.operation.status.toUpperCase()
            : '';
          const user_firm_id = parseInt(this.$store.state.Auth.user.firm.id, 10);
          const order_firm_ids = [this.order.firm_id, this.order.created_by_firm_id];
          return (
            this.canManageOperationsByUserBoolean
            && (
              operation_status != 'DRAFT'
                ? (user_firm_id == this.order.firm_id)
                : order_firm_ids.includes(user_firm_id)
            )
          );
        },
        canForceDeleteOperation() {
          return !this.operation.operationId && this.$store.getters["Auth/hasPermission"]("can force delete operation");
        },
        canManageOperations() {
          return this.$store.getters["OrderState/getStateByKey"](
            "can_manage_operations"
          );
        },
        canManageOperationsBoolean() {

          // return true;

          // Because it's a pain to keep checking (canManageOperations && canManageOperations.value)
          const obj = this.$store.getters["OrderState/getStateByKey"]("can_manage_operations");
          return obj && obj.value;
        },
        canManageOperationsByUser() {
          return this.$store.getters["OrderState/getStateByKey"](
            "can_manage_operations_by_user"
          );
        },
        canManageOperationsByUserBoolean() {
          return this.canManageOperationsByUser && this.canManageOperationsByUser.value;
        },
        canManageClaimLines() {
          return this.$store.getters["OrderState/getStateByKey"](
            "can_manage_claim_lines"
          );
        },
        canManageClaimLinesByUser() {
          return this.$store.getters["OrderState/getStateByKey"](
            "can_manage_claim_lines_by_user"
          );
        },
        canBeCompletedByUser() {
          return this.$store.getters["OrderState/getStateByKey"](
            "can_be_completed_by_user"
          );
        },
        // Can user operation
        canUpdate() {
          const validators = [
            "must belong to same firm",
            "must be allowed status"
          ];

          const params = {
            allowedStatuses: [
              "APPROVED",
              "PROGRAMMED",
              "STARTED",
              "MADE_SAFE",
              "PHYSICALLY_COMPLETED"
            ]
          };

          return ConfigurationValidator.validate(validators, this.order, params);
        },
        isCompleted() {
          return this.order.status === "COMPLETED";
        },
        canComplete() {
          const statuses = this.$options.statuses.map(status => status.value);

          const validators = [
            "must have claim declaration",
            "must have asset declaration",
            "must have summary codes",
            "must be allowed status"
          ];
          const model = {
            ...this.operation,
            claimLines: this.claimLines
          };
          const params = {
            allowedStatuses: statuses
          };

          return (
            this.order.status === "PHYSICALLY_COMPLETED" &&
            ConfigurationValidator.validate(validators, model, params)
          );
        },
        canInvoiceInternalOrders() {
          if (
            this.order.createdByFirm &&
            this.order.createdByFirm.id === this.order.firm.id
          ) {
            return (
              this.order.createdByFirm.permissions.findIndex(
                permission => permission.name === "must invoice internal orders"
              ) > -1
            );
          }

          return true;
        },
        canCommentOnOperations() {
          if (this.order.createdByFirm) {
            return (
              this.order.createdByFirm.permissions.findIndex(
                permission => permission.name === "can comment on operations"
              ) > -1
            );
          }

          return true;
        },
        canChangeActivity() {
          return this.operation.activityCode
            ? this.$store.getters["Auth/hasFirmPermission"]("can change activity")
            : true;
        },
        // Order/Responsibilty Pair
        // 'CALLOUT' hack for small waters - there should only be one or the other available in dropdown// 'CALLOUT' hack for small waters - there should only be one or the other available in dropdown
        ORPair() {
          // First operation will have OR if order has problem code
          // Rest of operations will have FR
          return this.isFirst && this.order && this.order.problemCode;
          // return (
          //   this.order &&
          //   this.operation &&
          //   (
          //     (
          //       // this.order.is_integrated === 1 &&
          //       this.operation.operationId === "0010"
          //     )
          //     &&
          //     (
          //       // this.order.is_integrated === null &&
          //       this.operation.activityCode &&
          //       (this.operation.activityCode.code.toUpperCase() === 'CALL' || this.operation.activityCode.code.toUpperCase() === 'CALLOUT')
          //     )
          //   )
          // );
        },
        areSummaryCodesEnabled() {
          // NOTE: See areSummaryCodesRelevant comments for differences.
          return (
            this.areSummaryCodesRelevant
            &&
            (this.order && this.order.firm_id == this.$store.state.Auth.user.firm.id)
          );
        },
        areSummaryCodesRelevant() {
          // This should determine whether the user has progressed far enough
          // that options should be fetched and loaded into the dropdowns.
          // NOTE: This is different from areSummaryCodesEnabled which
          // controls whether the dropdowns are in a disabled state.
          // (sometimes dropdowns must be populated but disabled)
          return (this.form.activityType) ? true : false;
        },
        operationCodes() {
          // Need to map code id to its code type
          // so it will be easier to remove specific code
          // e.g.
          // const { activity, ...codes } = orderCodes
          // const ids = Object.values(codes)
          // activity type chained params = { ids, type: 'ACTIVITY' }
          const codes = {};

          if (this.order.orderTypeCode) {
            codes['ORDERTYPE'] = this.order.orderTypeCode.id;
          }

          if (this.order.orderSubtypeCode) {
            codes['ACTIVITYTYPE'] = this.order.orderSubtypeCode.id;
          }

          if (this.order.problemCode) {
            codes['PROBLEM'] = this.order.problemCode.id;
          }

          if (this.form.activityType) {
            codes['ACTIVITY'] = this.form.activityType;
          }

          if (this.operation.asset && this.operation.asset.code) {
            codes['ASSET'] = this.operation.asset.code.id;
          }

          if (this.form.outcomeCode) {
            codes['REACTIVE'] = this.form.outcomeCode;
          }

          if (this.form.responsibilityCode) {
            codes['RESPONSE'] = this.form.responsibilityCode;
          }

          if (this.form.failureCode) {
            codes['FAILURE'] = this.form.failureCode;
          }

          if (this.form.repairCode) {
            codes['REPAIR'] = this.form.repairCode;
          }

          return codes;
        },
        canManageOrders() {
          return this.$store.getters["Auth/hasPermission"]("can manage orders");
        },
      },
      async mounted() {
        this.status = this.operation.status || "";
        // this.setNotesHeight();
        this.setForm();
        this.getAssociated();
      },
      methods: {

        getAssociated() {
          // let ids = this.firm.firm.associated.map(element => element.id);
          AssociatedService.getAssociated({id: this.order.created_by_firm_id, includes: 'tags'}).then(response => {
            this.associated = Object.values(response).filter(element => {
              if (element.tags.length) {
                return element.tags.filter(element => element.name.toLowerCase() == 'customer' && element.pivot.archived_at == null).length;
              }else {
                return false;
              }
            });
          });
        },

        viewMap() {
          // this.$emit("view-map", this.operation);
          this.operationModal.active = true;
        },
        allClaimLinesDeleted(){
          if(this.operation.status != 'APPROVED'){
            if(this.claimLines.length == 0){
              this.status = 'APPROVED';
            }
          }

        },
        async complete(id) {
          this.completing = true;

          try {
            const operation = await this.$options.orderOperationService
              .complete(id)
              .then(response => JsonDenormalizer.denormalize(response));

            this.operation.status = operation.status;
            this.status = status;

            this.$buefy.toast.open({
              message: "Order operation has been completed.",
              type: "is-info",
              position: "is-top-right"
            });
          } catch (err) {}

          this.completing = false;
        },
        transformedData() {
          return {
            orderId: this.order.id,
            description: this.form.description,
            activityCodeId: this.form.activityType,
            ownerFirmId: this.form.activityOwner,
            outcomeCodeId: this.form.outcomeCode,
            responsibilityCodeId: this.form.responsibilityCode,
            failureCodeId: this.form.failureCode,
            repairCodeId: this.form.repairCode,
            locationId: this.operation.asset && this.operation.asset.code
              ? this.operation.asset.code.code
              : "",
            assetId: this.operation.asset ? this.operation.asset.id : "",
            noAsset: this.operation.noAsset,
            includes: this.includes
          };
        },
        async validateCodes() {
          try {
            await this.$options.codeService.chained({
              ids: this.getOperationCodeIds(),
              contract_id: this.order.contract_id || undefined,
            });
          } catch (err) {
            throw err;
          }

          return;

          // Collect codes to be validated
          const codes = [];

          if (this.order.orderTypeCode) {
            codes.push(this.order.orderTypeCode.id);
          }

          if (this.order.orderSubtypeCode) {
            codes.push(this.order.orderSubtypeCode.id);
          }

          // Problem code needs to be validated when order type is REACTIVE
          if (this.ORPair && this.order.problemCode) {
            codes.unshift(this.order.problemCode.id);
          }

          if (this.form.activityType) {
            codes.unshift(this.form.activityType);
          }

          // Asset code needs to be validated when order type is not REACTIVE
          if (!this.ORPair && this.operation.asset && this.operation.asset.code) {
            codes.unshift(this.operation.asset.code.id);
          }

          const summaryCodes = [];

          if (this.ORPair) {
            if (this.form.outcomeCode) {
              summaryCodes.push(this.form.outcomeCode);
            }

            if (this.form.responsibilityCode) {
              summaryCodes.push(this.form.responsibilityCode);
            }
          } else {
            if (this.form.failureCode) {
              summaryCodes.push(this.form.failureCode);
            }

            if (this.form.repairCode) {
              summaryCodes.push(this.form.repairCode);
            }
          }

          try {
            if (summaryCodes.length) {
              await Promise.all(
                summaryCodes.map(summaryCode =>
                  this.$options.codeService.validateAssociations([
                    summaryCode,
                    ...codes
                  ])
                )
              );
            } else {
              await this.$options.codeService.validateAssociations(codes);
            }
          } catch (err) {
            throw err;
          }
        },
        async update() {
          this.updating = true;

          try {
            await this.validateCodes();

            const operation = await this.$options.orderOperationService
              .update(this.operation.id, this.transformedData())
              .then(response => JsonDenormalizer.denormalize(response));

            // Set order state
            this.$store.dispatch("OrderState/fetchState", this.order.id);

            this.$buefy.toast.open({
              message: "Order operation has been updated.",
              type: "is-info",
              position: "is-top-right"
            });
            this.$set(this.operation, "status", operation.status);
            this.$emit("update:operation", operation);
          } catch (err) {}

          this.updating = false;
        },
        async updateStatus() {

          const updatingOrDeleting = this.status.toUpperCase() == 'REJECTED'
            ? 'deleting'
            : 'updating';

          this.$set(this, updatingOrDeleting, true);

          try {
            const operation = await this.$options.orderOperationService
              .updateStatus(this.operation.id, { status: this.status })
              .then(response => JsonDenormalizer.denormalize(response));

            this.$set(this.operation, "status", operation.status);

            // Set order state
            this.$store.dispatch("OrderState/fetchState", this.order.id);

            this.$buefy.toast.open({
              message: this.status == "REJECTED" ? "Order operation has been deleted." : "Order operation status has been updated.",
              type: "is-info",
              position: "is-top-right"
            });

            if(this.status == "REJECTED"){
              this.$emit('order-operation-deleted', this.operation)
            }

          } catch (err) {}

          this.$set(this, updatingOrDeleting, false);
        },
        updateActivityOwner() {
          this.$nextTick(async () => {
            try {
              await this.$options.orderOperationService
                .setOwnerFirmid({
                  orderId: this.order.id,
                  firm_owner_id: this.form.activityOwner,
                  ids: [this.operation.id],
                });

              this.$buefy.toast.open({
                message: "Activity owner has been updated.",
                type: "is-info",
                position: "is-top-right"
              });

            } catch (err) {}
          });
        },
        openNoteModal() {
          this.$refs.notes.onCreate();
        },
        openClaimLineModal() {
          this.$refs.claimLines.onCreate();
        },
        setNotesHeight() {
          this.notesHeight = 0;

          this.$nextTick(() => {
            this.notesHeight = this.$refs.noteRow.clientHeight;
          });
        },
        setForm() {
          if (this.operation) {
            this.form = {
              description: this.operation.description || "",
              activityType: this.operation.activityCode ? this.operation.activityCode.id : "",
              activityOwner: this.operation.ownerFirm ? this.operation.ownerFirm.id : "",
              outcomeCode: this.operation.outcomeCode ? this.operation.outcomeCode.id : "",
              responsibilityCode: this.operation.responsibilityCode ? this.operation.responsibilityCode.id : "",
              failureCode: this.operation.failureCode ? this.operation.failureCode.id : "",
              repairCode: this.operation.repairCode ? this.operation.repairCode.id : ""
            };

            const assetCodeId = this.operation.asset && this.operation.asset.code ? this.operation.asset.code.id : undefined;
          }
        },
        async fetchCodes() {
          let requests = [];

          requests.push(this.fetchSelectOptions(
            "selectActivityType",
            "form.activityType"
          ));

          if (this.areSummaryCodesRelevant) {
            if (this.ORPair) {
              requests.push(this.fetchSelectOptions("selectOutcomeCode", "form.outcomeCode"));
              requests.push(this.fetchSelectOptions(
                "selectResponsibilityCode",
                "form.responsibilityCode"
              ));
            } else {
              requests.push(this.fetchSelectOptions("selectFailureCode", "form.failureCode"));
              requests.push(this.fetchSelectOptions("selectRepairCode", "form.repairCode"));
            }
          }

          this.fetchingCodes = true;

          try {
            await Promise.all(requests);
          } catch (err) {}

          this.fetchingCodes = false;
        },
        fetchSelectOptions(ref, dataPath) {
          return this.$refs[ref].fetchOptions();
        },
        async onOperationModalSelect(asset) {
          this.$set(this.operation, "asset", asset);
        },
        onClaimLinesCreated() {
          // Set order state
          this.$store.dispatch("OrderState/fetchState", this.order.id);

          // Update operation status to BLRQ when the first claim line is added
          this.$nextTick(() => {
            if (this.claimLines.length === 1) {
              this.status = "BLRQ";
            }
          });
        },
        onClaimLinesRemoved() {
          // Set order state
          this.$store.dispatch("OrderState/fetchState", this.order.id);

          // Update operation status to "FINALISED_NOBILLING" when all claim lines are deleted
          this.$nextTick(() => {
            if (this.claimLines.length === 0) {
              this.status = "FINALISED_NOBILLING";
            }
          });
        },
        confirmDelete(){
          this.$buefy.dialog.confirm({
              title: 'Deleting activity',
              message: 'Are you sure you want to <b>delete</b> this activity?',
              confirmText: 'Delete activity',
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => this.status = 'REJECTED'
          })
        },
        getOperationCodeIds(types = "") {
          if (typeof types === "string") {
            types = types.split(",");
          }

          let { ...codes } = this.operationCodes;

          types.forEach(type => {
            const { [type]: excluded, ...rest } = codes;
            codes = rest;
          });

          return Object.values(codes);
        },
      },
    };

</script>


// WEBPACK FOOTER //
// src/components/Order/OrderOperation.vue